export const ADD_QUESTIONNAIRE = "ADD_QUESTIONNAIRE"
export const ADD_QUESTIONNAIRE_SUCCESS = "ADD_QUESTIONNAIRE_SUCCESS"
export const ADD_QUESTIONNAIRE_FAILED = "ADD_QUESTIONNAIRE_FAILED"

export const GET_QUESTIONNAIRE = "GET_QUESTIONNAIRE"
export const GET_QUESTIONNAIRE_SUCCESS = "GET_QUESTIONNAIRE_SUCCESS"
export const GET_QUESTIONNAIRE_FAILED = "GET_QUESTIONNAIRE_FAILED"
export const RESET_QUESTIONNAIRE = "RESET_QUESTIONNAIRE"

export const UPDATE_QUESTIONNAIRE = "UPDATE_QUESTIONNAIRE"
export const UPDATE_QUESTIONNAIRE_SUCCESS = "UPDATE_QUESTIONNAIRE_SUCCESS"
export const UPDATE_QUESTIONNAIRE_FAILED = "UPDATE_QUESTIONNAIRE_FAILED"

export const POST_QUESTIONNAIRE_RESULT = "POST_QUESTIONNAIRE_RESULT"
export const POST_QUESTIONNAIRE_RESULT_SUCCESS =
  "POST_QUESTIONNAIRE_RESULT_SUCCESS"
export const POST_QUESTIONNAIRE_RESULT_FAILED =
  "POST_QUESTIONNAIRE_RESULT_FAILED"

export const POST_QUESTIONNAIRE_DESIGN = "POST_QUESTIONNAIRE_DESIGN"
export const POST_QUESTIONNAIRE_DESIGN_SUCCESS =
  "POST_QUESTIONNAIRE_DESIGN_SUCCESS"
export const POST_QUESTIONNAIRE_DESIGN_FAILED =
  "POST_QUESTIONNAIRE_DESIGN_FAILED"

export const GET_QUESTIONNAIRE_LIST = "GET_QUESTIONNAIRE_LIST"
export const GET_QUESTIONNAIRE_LIST_SUCCESS = "GET_QUESTIONNAIRE_LIST_SUCCESS"
export const GET_QUESTIONNAIRE_LIST_FAILED = "GET_QUESTIONNAIRE_LIST_FAILED"
export const RESET_QUESTIONNAIRE_LIST = "RESET_QUESTIONNAIRE_LIST"

export const OPEN_DELETE_QUESTIONNAIRE_MODAL = "OPEN_DELETE_QUESTIONNAIRE_MODAL"
export const HIDE_DELETE_QUESTIONNAIRE_MODAL = "HIDE_DELETE_QUESTIONNAIRE_MODAL"
export const DELETE_QUESTIONNAIRE = "DELETE_QUESTIONNAIRE"
export const DELETE_QUESTIONNAIRE_SUCCESS = "DELETE_QUESTIONNAIRE_SUCCESS"
export const DELETE_QUESTIONNAIRE_FAILED = "DELETE_QUESTIONNAIRE_FAILED"

export const UPDATE_QUESTIONNAIRE_ORDER = "UPDATE_QUESTIONNAIRE_ORDER"
export const UPDATE_QUESTIONNAIRE_ORDER_SUCCESS =
  "UPDATE_QUESTIONNAIRE_ORDER_SUCCESS"
export const UPDATE_QUESTIONNAIRE_ORDER_FAILED =
  "UPDATE_QUESTIONNAIRE_ORDER_FAILED"

export const GET_QUESTIONNAIRE_REPLY = "GET_QUESTIONNAIRE_REPLY"
export const GET_QUESTIONNAIRE_REPLY_SUCCESS = "GET_QUESTIONNAIRE_REPLY_SUCCESS"
export const GET_QUESTIONNAIRE_REPLY_FAILED = "GET_QUESTIONNAIRE_REPLY_FAILED"
export const RESET_QUESTIONNAIRE_REPLY = "RESET_QUESTIONNAIRE_REPLY"

export const GET_QUESTIONNAIRE_SCORES = "GET_QUESTIONNAIRE_SCORES"
export const GET_QUESTIONNAIRE_SCORES_SUCCESS =
  "GET_QUESTIONNAIRE_SCORES_SUCCESS"
export const GET_QUESTIONNAIRE_SCORES_FAILED = "GET_QUESTIONNAIRE_SCORES_FAILED"

export const DELETE_QUESTIONNAIRE_SUBMISSION = "DELETE_QUESTIONNAIRE_SUBMISSION"
export const DELETE_QUESTIONNAIRE_SUBMISSION_SUCCESS =
  "DELETE_QUESTIONNAIRE_SUBMISSION_SUCCESS"
export const DELETE_QUESTIONNAIRE_SUBMISSION_FAILED =
  "DELETE_QUESTIONNAIRE_SUBMISSION_FAILED"

export const UPDATE_QUESTIONNAIRE_MENU_ITEM = "UPDATE_QUESTIONNAIRE_MENU_ITEM"
export const UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS =
  "UPDATE_QUESTIONNAIRE_MENU_ITEM_SUCCESS"
export const UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED =
  "UPDATE_QUESTIONNAIRE_MENU_ITEM_FAILED"

export const SET_UPDATE_FEATURE_ERROR_MODAL = "SET_UPDATE_FEATURE_ERROR_MODAL"
